import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Bell, CalendarDays, FileText } from "lucide-react";
import { IMAGES } from "@/lib/constants";
import { PageBanner } from "@/components/PageBanner";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const catColor = {
  Admission: "#E63946", Holiday: "#2A9D8F", Exam: "#F4A261", Event: "#0A192F", General: "#64748b", Circular: "#7c3aed",
};

export default function Notices() {
  const [notices, setNotices] = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.getNotices().then((r) => setNotices(r.data)).catch(() => {});
    api.getEvents().then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PageBanner title="Notices & News" subtitle="Stay updated with the latest announcements, circulars and events." image={IMAGES.independence} />

      <section className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <h2 className="font-head font-extrabold text-2xl text-navy mb-6 flex items-center gap-2"><Bell className="h-6 w-6 text-brandred" /> Notice Board</h2>
          <div className="space-y-4">
            {notices.length === 0 && <p className="text-slate-500">No notices available.</p>}
            {notices.map((n, i) => (
              <motion.div key={n.id} initial={{ opacity: 0, x: -14 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
                className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-transform">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs font-bold px-2.5 py-1 rounded-full text-white" style={{ backgroundColor: catColor[n.category] || "#64748b" }}>{n.category}</span>
                  <span className="text-xs text-slate-400 flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {n.date}</span>
                </div>
                <h3 className="font-head font-bold text-navy text-lg">{n.title}</h3>
                <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">{n.content}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="font-head font-extrabold text-2xl text-navy mb-6 flex items-center gap-2"><CalendarDays className="h-6 w-6 text-brandteal" /> Upcoming Events</h2>
          <div className="space-y-4">
            {events.length === 0 && <p className="text-slate-500">No events available.</p>}
            {events.map((e) => (
              <div key={e.id} className="bg-navy text-white rounded-2xl p-5">
                <div className="text-gold text-xs font-bold flex items-center gap-1 mb-1"><CalendarDays className="h-3.5 w-3.5" /> {e.date}</div>
                <h4 className="font-head font-bold">{e.title}</h4>
                <p className="text-sm text-slate-300 mt-1 leading-relaxed">{e.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
